<script lang="ts">
    import type { AuthLog, TwofaEntry } from './TwofaDefs'

    interface Props {
        entry: AuthLog
        twofaEntries?: { [key: string]: TwofaEntry }
    }

    let { entry, twofaEntries = {} }: Props = $props()

    function twofaText(e: TwofaEntry) {
        if (e.type == 'totp') return 'Authentificateur'
        if (e.type == 'sms') return `SMS (${e.code ? e.code : '–'})`
        if (e.type == 'email') return `Courriel (${e.code ? e.code : '–'})`
        return `??? (${e.type})`
    }
</script>

{#if entry.action == 'signin'}
    Connexion
{:else if entry.action == 'signout'}
    Déconnexion
{:else if entry.action == 'token-refresh'}
    « token-refresh »
{:else if entry.action == 'set-password'}
    Configuration du mot de passe
{:else if entry.action == 'set-email'}
    Configuration du courriel du compte
{:else if entry.action == 'lock'}
    Compte verrouillé
{:else if entry.action == 'unlock'}
    Compte déverrouillé
{:else if entry.action == 'lost-password-email'}
    Envoie d’un courriel de récup. de mot de passe
{:else if entry.action == 'welcome'}
    Envoie d’un courriel de bienvenue
{:else if entry.action == 'twofa-presignin'}
    Mot de passe OK, requiert seconde authentification
{:else if entry.action == 'add-passkey'}
    Ajout d’une clé d’accès
{:else if entry.action == 'remove-passkey'}
    Retrait d’une clé d’accès
{:else if entry.action == 'add-otp'}
    Ajout OTP :
    {#if entry.entry_id && twofaEntries[entry.entry_id]}
        {twofaText(twofaEntries[entry.entry_id])}
    {:else}
        (inconnu)
    {/if}
{:else if entry.action == 'remove-otp'}
    Retrait OTP :
    {#if entry.entry_id && twofaEntries[entry.entry_id]}
        {twofaText(twofaEntries[entry.entry_id])}
    {:else}
        (inconnu)
    {/if}
{:else}
    ??? ({entry.action})
{/if}
